import React from 'react'
import styled from 'styled-components'

import { Button } from '@sketch/components'
import { ReactComponent as Apple } from '@sketch/icons/img-apple-17'

export const AppleIcon = styled(Apple)`
  width: 17px;
  height: 17px;
`

export const StyledAppleButton = styled(Button)`
  grid-area: apple;
  flex: 1;
  overflow: hidden;
  flex-wrap: wrap;

  color: ${({ theme }) => theme.colors.foreground.secondary.B};

  :hover {
    color: ${({ theme }) => theme.colors.foreground.secondary.B};
  }

  @media (prefers-color-scheme: dark) {
    box-shadow: none;
    border: none;
  }
`

export const Text = styled.span`
  margin-top: 2px;
`

export interface ContinueWithAppleProps {
  onClick: () => void
  loading?: boolean
  disabled?: boolean
  className?: string
}

export const ContinueWithApple = ({
  onClick,
  loading = false,
  disabled,
  className,
}: ContinueWithAppleProps) => {
  return (
    <StyledAppleButton
      className={className}
      variant="secondary"
      size="40"
      fill
      onClick={onClick}
      loading={loading}
      icon={AppleIcon}
      disabled={disabled}
    >
      <Text>Continue with Apple</Text>
    </StyledAppleButton>
  )
}
